// extracted by mini-css-extract-plugin
export default {"titleContainer":"huetpVlIydU6OHMzGYN2","roleIcon":"VA2ZE8PtR2QI_unkAiWn","title":"lrUXcTOm4CcBK7aUB2kZ","text1":"GX7daGOLxmMDkYxpeKGZ","text2":"it4SSu_wrEZVKCFXVd0Q"};